import createAssetGetter from './createAssetGetter.js';

export const LoadingIcon = createAssetGetter('img/loading.gif');

// Social media
export const InstagramLogo = createAssetGetter('img/Instagram.svg');
export const InstagramLogoWhite = createAssetGetter('img/InstagramWhite.svg');
export const FacebookLogo = createAssetGetter('img/Facebook.svg');
export const FacebookLogoWhite = createAssetGetter('img/FacebookWhite.svg');
export const YouTubeLogo = createAssetGetter('img/YouTube.svg');
export const YouTubeLogoWhite = createAssetGetter('img/YouTubeWhite.svg');
export const TwitterLogo = createAssetGetter('img/Twitter.svg');
export const TwitterLogoWhite = createAssetGetter('img/TwitterWhite.svg');
export const FacebookShareIcon = createAssetGetter('img/FacebookShare.png');
export const TwitterShareIcon = createAssetGetter('img/TwitterShare.png');
export const GooglePlayIcon = createAssetGetter('img/GooglePlay.png');
export const ShareSocialIcon = createAssetGetter('img/ShareSocial.svg');
export const HudlLogo = createAssetGetter('img/Hudl-logo.jpg');
